<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 font-weight-medium']">Project -</span>
      <span :class="['headline indigo--text text--darken-2 ml-2']">{{ clientName }}</span>
      <v-spacer></v-spacer>
      <v-btn class="mt-n3 mr-n3" fab dark x-small color="rgb(167, 167, 167)" @click="closeForm">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row class>
        <v-col sm="6" lg="4" class="section">
          <SectionInfo></SectionInfo>
        </v-col>
        <v-col sm="6" lg="4" class="section">
          <SectionClient class="section"></SectionClient>
        </v-col>
        <v-col sm="6" lg="4">
          <SectionWorkItems class="section"></SectionWorkItems>
        </v-col>
        <v-col sm="6" lg="4">
          <SectionInvoices class="section"></SectionInvoices>
        </v-col>
        <v-col sm="6" lg="4">
          <SectionExpenses class="section"></SectionExpenses>
        </v-col>
        <v-col sm="6" lg="4">
          <SectionTimesheets class="section"></SectionTimesheets>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="dummy">Save</v-btn>
      <v-btn color="green darken-1" text @click="dummy">Cancel</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { section_Shared } from "@/components/project/sections/section_Shared";
import SectionInfo from "@/components/project/sections/SectionInfo";
import SectionClient from "@/components/project/sections/SectionClient";
import SectionWorkItems from "@/components/project/sections/SectionWorkItems";
import SectionInvoices from "@/components/project/sections/SectionInvoices";
import SectionExpenses from "@/components/project/sections/SectionExpenses";
import SectionTimesheets from "@/components/project/sections/SectionTimesheets";

export default {
  name: "DialogProjectDesktop",
  components: {
    SectionInfo,
    SectionClient,
    SectionWorkItems,
    SectionInvoices,
    SectionExpenses,
    SectionTimesheets,
  },
  setup(props, context) {
    const { selectedProject } = section_Shared(context);

    const clientName = computed(() => {
      let client = selectedProject.value.client;
      if (!client) return "-- no client --";
      return `${client.addressLine1}, ${client.city}`;
    });

    function closeForm() {
      context.emit("close-form");
    }

    return {
      clientName,
      closeForm,
    };
  },
};
</script>

<style>
</style>